import { t } from '@lingui/macro'
import { isAuthorized } from 'helpers'

export const getLoyaltyRoutes = (
  userRoles,
  navigate,
  { annual_active, member_active, season_active }
) => {
  const has_annual =
    annual_active &&
    isAuthorized(userRoles, ['annual', 'annual_types', 'admin'])
  const has_member =
    member_active &&
    isAuthorized(userRoles, ['member', 'member_types', 'admin'])
  const has_season =
    season_active &&
    isAuthorized(userRoles, ['season', 'season_types', 'admin'])
  const has_settings = isAuthorized(userRoles, [
    'admin',
    'staff_planner',
    'event_planner',
    'room_planner'
  ])

  return [
    {
      label: t`Dashboard`,
      path: '/loyalty/dashboard',
      onClick: path => navigate(path)
    },
    {
      path: '/loyalty/annualpass',
      label: t`Annual Pass`,
      onClick: has_annual ? undefined : path => navigate(path),
      pages: has_annual && [
        {
          label: t`Annual Pass Holders`,
          path: '/loyalty/annualpass/holders',
          onClick: path => navigate(path)
        },
        {
          label: t`Annual Pass Types`,
          path: '/loyalty/annualpass/types',
          onClick: path => navigate(path)
        }
      ]
    },
    {
      path: '/loyalty/memberpass',
      label: t`Member Pass`,
      onClick: has_member ? undefined : path => navigate(path),
      pages: has_member && [
        {
          label: t`Member Pass Holders`,
          path: '/loyalty/memberpass/holders',
          onClick: path => navigate(path)
        },
        {
          label: t`Member Pass Types`,
          path: '/loyalty/memberpass/types',
          onClick: path => navigate(path)
        }
      ]
    },
    {
      path: '/loyalty/seasonpass',
      label: t`Season Pass`,
      onClick: has_season ? undefined : path => navigate(path),
      pages: has_season && [
        {
          label: t`Season Pass Holders`,
          path: '/loyalty/seasonpass/holders',
          onClick: path => navigate(path)
        },
        {
          label: t`Season Pass Types`,
          path: '/loyalty/seasonpass/types',
          onClick: path => navigate(path)
        }
      ]
    },
    {
      path: '/loyalty/settings',
      disabled: !has_settings,
      label: t`Settings`,
      onClick: path => navigate(path)
    }
  ]
}
